// @ts-ignore
import store from '../../../../../../../../store';
import {Graphics, InteractionEvent, Sprite, Texture} from 'pixi.js';
import EventApi from '../../../../../../../../api/EventsApi';
import {DraggableObject} from '../../../../../base/DraggableObject';
import {StaticData} from '../../../../../data/StaticData';
import {IPoint} from '../../../../../interfaces/primitives/IPoint';
import {DynamicData} from '../../../../../data/DynamicData';
import {BackgroundFilter} from './video_seat/BackgroundFilter';
import {GameState} from '../../../../../../../../../types/game-state';
import {PointsCounter} from './video_seat/PointsCounter';
import {NameHolder} from './video_seat/NameHolder';
import {CardsCounter} from './video_seat/CardsCounter';
import {MicIndicator} from './video_seat/MicIndicator';
import {BottomBar} from './video_seat/BottomBar';
import {LeaveButton} from './video_seat/LeaveButton';
import {NameInputEvents} from './video_seat/bottom_bar/name_input/NameInputEvents';
import {SizesSelector} from './video_seat/SizesSelector';
import {SizesSelectorButtonEvents} from './video_seat/sizes_selector/SizesSelectorButtonEvents';
import {ActivePlayerStroke} from './video_seat/ActivePlayerStroke';

export class VideoSeat extends DraggableObject
{
    private static bgFilter: BackgroundFilter = new BackgroundFilter();
    activePlayerStroke: ActivePlayerStroke;
    videoSpriteHolder: Sprite;
    graphicsMask: Graphics;
    graphicsBg: Graphics;
    pointsCounter: PointsCounter;
    micIndicator: MicIndicator;
    nameHolder: NameHolder;
    cardsCounter: CardsCounter;
    sizesSelector: SizesSelector;
    private videoSprite: Sprite | undefined;
    private updateVideoTimeout: number = 0;
    private bottomBar: BottomBar;
    private leaveButton: LeaveButton;
    private onMicrophoneClickBindThis: (e: Event) => void;
    private onLockByInputingNameBindThis: (e: Event) => void;
    private onUnlockByInputingNameBindThis: (e: Event) => void;
    private lockedByInputingName: boolean = false;
    private pointerOutTimeoout: number = 0;
    private onSizesButtonSelectedBindThis: (e: Event) => void;

    constructor(public playerId: string, private my: boolean) {
        super();
        this.videoSpriteHolder = new Sprite();

        this.activePlayerStroke = new ActivePlayerStroke();
        this.graphicsBg = new Graphics();
        this.updateColor();
        this.updateVideo();

        this.leaveButton = new LeaveButton(this.onClickLeave.bind(this));

        this.graphicsMask = new Graphics();
        this.graphicsMask.beginFill(0xffffff);
        this.graphicsMask.drawRoundedRect(0, 0, StaticData.videoSeatSizes.x, StaticData.videoSeatSizes.y, StaticData.videoSeatBorderRadius);
        this.graphicsMask.endFill();

        this.bottomBar = new BottomBar(this.playerId);
        this.pointsCounter = new PointsCounter(this.playerId);
        this.micIndicator = new MicIndicator();
        this.nameHolder = new NameHolder();
        this.cardsCounter = new CardsCounter(this.playerId);
        this.sizesSelector = new SizesSelector(this.playerId);

        this.addChild(this.activePlayerStroke);
        this.addChild(this.leaveButton);
        this.addChild(this.sizesSelector);
        this.addChild(this.graphicsBg);
        this.addChild(this.videoSpriteHolder).interactive = false;
        this.addChild(this.micIndicator).interactive = false;
        this.addChild(this.nameHolder).interactive = false;
        this.addChild(this.cardsCounter).interactive = false;
        this.addChild(this.bottomBar).interactive = false;
        this.addChild(this.pointsCounter);
        this.addChild(this.graphicsMask).interactive = false;

        this.pointsCounter.position.set(StaticData.videoSeatPointsCounterRadius + 16, StaticData.videoSeatSizes.y - StaticData.videoSeatBottomBarHeight / 2);
        this.micIndicator.position.set(86, StaticData.videoSeatSizes.y - StaticData.videoSeatBottomBarHeight / 2);
        this.updateNamePositionAndMicIndicatorVisibility();
        this.cardsCounter.position.set(StaticData.videoSeatSizes.x - 40, StaticData.videoSeatSizes.y - StaticData.videoSeatBottomBarHeight / 2);
        this.bottomBar.position.set(0, StaticData.videoSeatSizes.y - StaticData.videoSeatBottomBarHeight);
        this.leaveButton.position.set(StaticData.videoSeatSizes.x - StaticData.videoSeatLeaveButtonWidth, -StaticData.videoSeatBorderWidth + 1);
        this.sizesSelector.position.set(70, -34);

        this.videoSpriteHolder.mask = this.graphicsMask;
        this.bottomBar.mask = this.graphicsMask;
        this.graphicsBg.filters = [VideoSeat.bgFilter];

        this.bottomBar.visible = this.leaveButton.visible = this.my;
        this.leaveButton.visible = this.leaveButton.visible = this.my;
        this.sizesSelector.visible = this.sizesSelector.visible = !StaticData.isAdmin && this.my;

        this.onMicrophoneClickBindThis = this.onMicrophoneClick.bind(this);
        this.onLockByInputingNameBindThis = this.onLockByInputingName.bind(this);
        this.onUnlockByInputingNameBindThis = this.onUnlockByInputingName.bind(this);
        EventApi.addEventListener(EventApi.TABLE_MICROPHONE, this.onMicrophoneClickBindThis);
        addEventListener(NameInputEvents.LOCK_BY_INPUTING, this.onLockByInputingNameBindThis);
        addEventListener(NameInputEvents.UNLOCK_BY_INPUTING, this.onUnlockByInputingNameBindThis);

        this.onSizesButtonSelectedBindThis = this.onSizesButtonSelected.bind(this);
        addEventListener(SizesSelectorButtonEvents.SELECTED, this.onSizesButtonSelectedBindThis);

        this.setActive(false);
    }

    updateColor(): void {
        this.graphicsBg.clear();
        let playerColor = DynamicData.playersColorsMap.get(this.playerId);
        let color: string = playerColor ? playerColor.split('#')[1] : '777777';
        let colorHex: number = parseInt('0x' + color);
        this.graphicsBg.beginFill(colorHex);
        this.graphicsBg.drawRoundedRect(
            -StaticData.videoSeatBorderWidth,
            -StaticData.videoSeatBorderWidth,
            StaticData.videoSeatSizes.x + StaticData.videoSeatBorderWidth * 2,
            StaticData.videoSeatSizes.y + StaticData.videoSeatBorderWidth * 2,
            StaticData.videoSeatBorderRadius + StaticData.videoSeatBorderWidth
        );
        this.graphicsBg.endFill();

        this.activePlayerStroke.updateColor(colorHex);
    }

    clampPos(x: number, y: number): IPoint {
        /*let selectedStacksRectangle: Rectangle = StackSelector.getSelectedStacksRectangle();
        x = PixiUtil.clamp(this.x - selectedStacksRectangle.left, x, ActiveData.root.width - selectedStacksRectangle.right + this.x);
        y = PixiUtil.clamp(this.y - selectedStacksRectangle.top, y, ActiveData.root.height - selectedStacksRectangle.bottom + this.y);*/
        return {x, y};
    }

    onDragMove(e: InteractionEvent): void {
        super.onDragMove(e);
        e.stopPropagation();
    }

    async onPointerDown(e: InteractionEvent): Promise<void> {
        super.onPointerDown(e);

        e.stopPropagation();
    }

    parsePlayerData(playerData: GameState.TPlayerData) {
        this.pointsCounter.value = playerData.points;
        let playerName: string = playerData.customName || playerData.name!;
        this.nameHolder.value = playerName;

        this.bottomBar.nameInput.playerName = playerName;
        this.updateColor();
        window.clearTimeout(this.updateVideoTimeout);
        this.updateVideoTimeout = window.setTimeout(() => this.updateVideo(), 4000);
    }

    /**
     * Обработчик события pointerover
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerOver(e: InteractionEvent): void {
        this.bottomBar.appear();
        this.leaveButton.appear();
        this.sizesSelector.appear();
    }

    /**
     * Обработчик события pointerout
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerOut(e: InteractionEvent): void {
        this.pointerOutTimeoout = window.setTimeout(this.processPointerOut.bind(this), 10);
    }

    processPointerOut(): void {
        if (this.lockedByInputingName) {
            return;
        }
        this.bottomBar.appear(false);
        this.leaveButton.appear(false);
        this.sizesSelector.appear(false);
    }

    destroy(): void {
        EventApi.removeEventListener(EventApi.TABLE_MICROPHONE, this.onMicrophoneClickBindThis);
        delete this.onMicrophoneClickBindThis;

        removeEventListener(SizesSelectorButtonEvents.SELECTED, this.onSizesButtonSelectedBindThis);
        delete this.onSizesButtonSelectedBindThis;

        super.destroy();
    }

    setActive(master: boolean) {
        this.activePlayerStroke.visible = master;
    }

    private onSizesButtonSelected(e: Event): void {
        let data: {playerId: string, index: number} = (e as MessageEvent).data;
        if (data.playerId != this.playerId) {
            return;
        }

        this.scale.set(StaticData.videoSeatScales[data.index]);
    }

    private onClickLeave(): void {
        EventApi.triggerEvent(EventApi.EXIT_SEAT, {playerId: this.playerId});
    }

    private addVideoBtn(x: number, y: number, cb: () => void): Sprite {
        const btn = new Sprite(Texture.WHITE);
        btn.position.set(x, y);
        btn.interactive = true;
        btn.buttonMode = true;
        btn.on('pointerup', e => {
            e.data.originalEvent.stopPropagation();
            cb();
        });
        return btn;
    }

    private updateVideo(): void {
        if (this.videoSprite) {
            this.videoSpriteHolder.removeChild(this.videoSprite);
            if (this.videoSprite.texture === Texture.WHITE) {
                this.videoSprite.destroy({children: true});
            } else {
                this.videoSprite.destroy({children: true, texture: true, baseTexture: true});
            }

        }

        const video = document.querySelector(
            this.my
                ? '#seatsHolder #localSeat video'
                : `#seatsHolder:not(#localSeat) video[id*="${this.playerId}"]`
        ) as HTMLVideoElement | null;

        console.warn(video ? 'presents' : 'no presents', this.playerId);
        if (video) {
            this.videoSprite = new Sprite(Texture.from(video));
        } else {
            this.videoSprite = new Sprite(Texture.WHITE);
        }

        this.videoSprite.width = StaticData.videoSeatSizes.x;
        this.videoSprite.height = StaticData.videoSeatSizes.y;

        this.videoSpriteHolder.addChild(this.videoSprite);
    }

    private updateNamePositionAndMicIndicatorVisibility() {
        let micEnabled: boolean = store.getters.getMicrophoneStatus;
        this.nameHolder.position.set(micEnabled ? 76 : 106, StaticData.videoSeatSizes.y - StaticData.videoSeatBottomBarHeight / 2);
        this.micIndicator.visible = !micEnabled;
    }

    private onMicrophoneClick() {
        this.updateNamePositionAndMicIndicatorVisibility();
    }

    private onUnlockByInputingName(): void {
        this.lockedByInputingName = false;
        this.processPointerOut();
    }

    private onLockByInputingName(): void {
        this.lockedByInputingName = true;
    }
}
